import { App } from 'vue';
import _ from "lodash";

export function registerGlobalComponents(app: App): void {
    const requireComponent = require.context(
    // The relative path of the components folder
    './',
    true,
    // The regular expression used to match lcs component filenames
    /[A-Z]\w+\.(vue)$/
    )
    requireComponent.keys().forEach(fileName => {
        if (fileName) {
            // Get component config
            const componentConfig = requireComponent(fileName)
            // Get PascalCase name of component
            const componentName = _.upperFirst(
                _.camelCase(
                    // Gets the file name regardless of folder depth
                    (fileName.split('/').pop() || '')
                        .replace(/\.\w+$/, '')
                )
            )
            // Register component globally
            app.component(
            componentName,
            // Look for the component options on `.default`, which will
            // exist if the component was exported with `export default`,
            // otherwise fall back to module's root.
            componentConfig.default || componentConfig
            )
        }
    });
}